import React from 'react';
import ReactDOM from 'react-dom/client';
// As fontes vêm primeiro: são as mesmas do Nexus (Inter e JetBrains Mono),
// auto-hospedadas para o desktop funcionar sem internet.
import './assets/fontes/fontes.css';
import './styles/base.css';
import OrionShell from './pages/OrionShell';
import TicketExpandido from './pages/TicketExpandido';
import { OrionProvider } from './context/OrionContext';
import { ehJanelaExpandida } from './services/plataforma';

// Cada janela decide o que é pelo hash: '#expandido' é o ticket formalizado
// aberto em janela própria; qualquer outra roda o Orion inteiro.
// É o mesmo bundle nos dois casos — e o mesmo que roda no navegador.
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {ehJanelaExpandida()
      ? <TicketExpandido />
      : <OrionProvider><OrionShell /></OrionProvider>}
  </React.StrictMode>
);
